import { useConfigure } from "../connectors/useConfigure.js";
export function Configure(props) {
  useConfigure(props, {
    $$widgetType: 'ais.configure'
  });
  return null;
}